import React from 'react';
import LegalLayout from './LegalLayout';

const TermsPage = () => {
  const sections = [
    { id: 'article-1', label: '제1조 (목적)' },
    { id: 'article-2', label: '제2조 (정의)' },
    { id: 'article-3', label: '제3조 (약관의 게시와 개정)' },
    { id: 'article-4', label: '제4조 (회원가입)' },
    { id: 'article-5', label: '제5조 (서비스의 제공 및 변경)' },
    { id: 'article-6', label: '제6조 (서비스의 중단)' },
    { id: 'article-7', label: '제7조 (회원탈퇴 및 자격 상실)' },
    { id: 'article-8', label: '제8조 (면책조항)' },
    { id: 'article-9', label: '제9조 (준거법 및 재판관할)' },
  ];

  return (
    <LegalLayout
      title="이용약관"
      lastUpdated="2025년 1월 20일"
      sections={sections}
    >
      <section id="article-1" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">제1조 (목적)</h2>
        <p>
          본 약관은 (주)모바일장례서비스(이하 "회사")가 제공하는 장례 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
        </p>
      </section>

      <section id="article-2" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">제2조 (정의)</h2>
        <ul className="list-decimal list-inside space-y-2 ml-4">
          <li>"서비스"란 회사가 제공하는 부고 등록, 화환 주문 등의 모든 서비스를 의미합니다.</li>
          <li>"회원"이란 본 약관에 동의하고 회사가 제공하는 서비스를 이용하는 자를 말합니다.</li>
          <li>"아이디(ID)"란 회원의 식별과 서비스 이용을 위하여 회원이 설정하고 회사가 승인한 문자와 숫자의 조합을 의미합니다.</li>
        </ul>
      </section>

      <section id="article-3" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">제3조 (약관의 게시와 개정)</h2>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.</li>
          <li>회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
          <li>회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 서비스 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.</li>
        </ol>
      </section>

      <section id="article-4" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">제4조 (회원가입)</h2>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.</li>
          <li>회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.
            <ul className="list-disc list-inside ml-6 mt-2">
              <li>등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
              <li>기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우</li>
            </ul>
          </li>
        </ol>
      </section>

      <section id="article-5" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">제5조 (서비스의 제공 및 변경)</h2>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>회사는 다음과 같은 서비스를 제공합니다.
            <ul className="list-disc list-inside ml-6 mt-2">
              <li>부고 등록 및 관리 서비스</li>
              <li>화환 주문 및 배송 서비스</li>
              <li>고객 지원 서비스</li>
              <li>기타 회사가 추가 개발하거나 제휴계약 등을 통해 회원에게 제공하는 일체의 서비스</li>
            </ul>
          </li>
          <li>회사는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다.</li>
        </ol>
      </section>

      <section id="article-6" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">제6조 (서비스의 중단)</h2>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>회사는 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</li>
          <li>회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 회사가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</li>
        </ol>
      </section>

      <section id="article-7" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">제7조 (회원탈퇴 및 자격 상실)</h2>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원탈퇴를 처리합니다.</li>
          <li>회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다.
            <ul className="list-disc list-inside ml-6 mt-2">
              <li>가입 신청 시에 허위 내용을 등록한 경우</li>
              <li>타인의 서비스 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우</li>
              <li>서비스를 이용하여 법령 또는 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li>
            </ul>
          </li>
        </ol>
      </section>

      <section id="article-8" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">제8조 (면책조항)</h2>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</li>
          <li>회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</li>
        </ol>
      </section>

      <section id="article-9" className="scroll-mt-24">
        <h2 className="text-xl font-semibold text-primary mb-4">제9조 (준거법 및 재판관할)</h2>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>본 약관의 해석 및 적용은 대한민국 법령을 준거법으로 합니다.</li>
          <li>서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 회사의 본사 소재지를 관할하는 법원을 관할 법원으로 합니다.</li>
        </ol>
      </section>

      <div className="mt-8 p-4 bg-accent-50 rounded-lg border border-accent-200">
        <p className="text-sm text-accent-700">
          본 이용약관은 프론트엔드 목업 프로젝트를 위한 예시 문서입니다.
          실제 서비스에서는 법률 전문가의 검토를 받은 문서를 사용해야 합니다.
        </p>
      </div>
    </LegalLayout>
  );
};

export default TermsPage;
